<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-full w-full mb-base">
        <vx-card :title="$t('_pages.profile.title')">
          <div class="vx-row mb-4 mt-1">
            <div class="vx-col w-full">
              <form @submit.prevent="handleSubmit('profile-form')" data-vv-scope="profile-form">
                <div class="vx-row">
                  <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 pb-2">
                    <vs-input
                      @keyup.enter.native="handleSubmit"
                      name="first_name"
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label-placeholder="$t('first_name')"
                      v-model="first_name"
                      :data-vv-as="$t('first_name')"
                      v-validate="'required|min:3'"
                      class="w-full no-icon-border"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('profile-form.first_name')"
                    >{{ errors.first('profile-form.first_name') }}</span>
                  </div>

                  <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 pb-2">
                    <vs-input
                      @keyup.enter.native="handleSubmit"
                      name="last_name"
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label-placeholder="$t('last_name')"
                      v-model="last_name"
                      :data-vv-as="$t('last_name')"
                      v-validate="'required'"
                      class="w-full no-icon-border"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('profile-form.last_name')"
                    >{{ errors.first('profile-form.last_name') }}</span>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col w-full pb-2">
                    <vs-input
                      @keyup.enter.native="handleSubmit"
                      name="email"
                      icon="icon icon-mail"
                      icon-pack="feather"
                      :label-placeholder="$t('email')"
                      v-model="email"
                      v-validate="'required|email'"
                      :data-vv-as="$t('email')"
                      class="w-full no-icon-border pt-1"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('profile-form.email')"
                    >{{ errors.first('profile-form.email') }}</span>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-full">
                    <vs-checkbox
                      @click="clearPass"
                      name="change_password"
                      v-model="change_password"
                      class
                    >{{ $t('_pages.profile.you_want_change_password' )}}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-row mt-2" v-if="change_password">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      @keyup.enter.native="handleSubmit"
                      type="password"
                      name="password"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      :label-placeholder="$t('password')"
                      v-model="password"
                      v-validate="'required|min:6|max:15'"
                      :data-vv-as="$t('password')"
                      ref="password"
                      class="w-full no-icon-border"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('profile-form.password')"
                    >{{ errors.first('profile-form.password') }}</span>
                  </div>

                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      @keyup.enter.native="handleSubmit"
                      type="password"
                      name="password_confirmation"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      v-validate="'required|min:6|max:15|confirmed:password'"
                      :label-placeholder="$t('password_confirmation')"
                      v-model="password_confirmation"
                      :data-vv-as="$t('password_confirmation')"
                      class="w-full no-icon-border"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('profile-form.password_confirmation')"
                    >{{ errors.first('profile-form.password_confirmation') }}</span>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-full">
                    <vs-checkbox
                      name="mail_risk_informative"
                      v-model="mail_risk_informative"
                      class
                    >{{ $t('_pages.profile.receive_informative_risk_alert_mail' )}}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-full">
                    <vs-checkbox
                      name="mail_risk_low"
                      v-model="mail_risk_low"
                      class
                    >{{ $t('_pages.profile.receive_low_risk_alert_mail' )}}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-full">
                    <vs-checkbox
                      name="mail_risk_moderate"
                      v-model="mail_risk_moderate"
                      class
                    >{{ $t('_pages.profile.receive_moderate_risk_alert_mail' )}}</vs-checkbox>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-full">
                    <vs-checkbox
                      name="mail_risk_high"
                      v-model="mail_risk_high"
                      class
                    >{{ $t('_pages.profile.receive_high_risk_alert_mail' )}}</vs-checkbox>
                  </div>
                </div>

                <div class="flex flex-wrap justify-between mt-6">
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/4 xl:w-1/4 mb-4">
                    <vs-button
                            @click="$router.push({name: 'alertsPage'})"
                            type="border"
                            class="w-full"
                    >{{ $t('cancel') }}</vs-button>
                  </div>
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/4 xl:w-1/4 mb-4">
                    <vs-button class="w-full">{{ $t('save') }}</vs-button>
                  </div>
                </div>
              </form>

              <vs-divider></vs-divider>

              <h4>{{ $t('_pages.profile.license' )}}</h4>

              <div class="mt-6">
                <div class="flex flex-wrap justify-between">
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/2 xl:w-1/2">
                      <span >
                        <span>{{ $t('_pages.profile.activation_key' )}}: </span>
                        <span v-text="license_key"></span>
                      </span>
                  </div>
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/2 xl:w-1/2 mb-2 text-right">
                    <span>{{ $t('_pages.profile.expiration_date' )}}: </span>
                    <span class="bullet bullet-danger svg-font-small-3 mr-50 cursor-pointer"></span>
                    <span v-text="license_end" v-bind:class="license_end_color"></span>
                  </div>
                </div>
              </div>
              <div class="mt-6" v-show="license_expired">
                <div class="flex flex-wrap justify-between">
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/2 xl:w-1/2">
                  </div>
                  <div class="w-full sm:w-full md:w-1/4 md:pr-4 lg:w-1/4 xl:w-1/4 mb-2 text-right">
                    <vs-button
                            @click="new_license=true"
                            type="border"
                            class="cursor-pointer"
                    >{{ $t('_pages.profile.active_new_license' )}}</vs-button>
                  </div>
                </div>
              </div>

              <vs-divider></vs-divider>

              <h4>LGPD</h4>

              <div class="mt-6">
                <div class="flex flex-wrap justify-between">
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/4 xl:w-1/4 mb-4">
                    <vs-button
                            @click="$router.push({name: 'deletePage'})"
                            color="danger"
                            type="border"
                            class="w-full"
                    >{{ $t('_pages.profile.delete_my_account' )}}</vs-button>
                  </div>
                  <div class="w-full sm:w-full md:w-1/2 md:pr-2 lg:w-1/4 xl:w-1/4 mb-4 text-right">
                        <span class="cursor-pointer mt-1 ml-4 feather-icon select-none relative" :title="$t('_pages.profile.export_data')" @click="data_export">
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
                                <polyline points="16 6 12 2 8 6"></polyline>
                                <line x1="12" y1="2" x2="12" y2="15"></line>
                            </svg>
                        </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- POPUP NEW License -->
    <vs-popup :title="$t('_pages.popup_new_license.title')" :active.sync="new_license">
      <p>{{ $t('_pages.popup_new_license.body') }}</p>
      <form @submit.prevent="activeNewLicense('new-license-form')" data-vv-scope="new-license-form">
        <div class="vx-col w-full">
          <vs-input
            @keyup.enter.native="activeNewLicense"
            name="key"
            icon="icon icon-shield"
            icon-pack="feather"
            autocomplete="none"
            :label-placeholder="$t('rescue_code')"
            v-model="key"
            v-validate="'required'"
            v-mask="key_mask"
            :data-vv-as="$t('rescue_code')"
            class="w-full no-icon-border pt-1"
          />
          <span class="text-danger text-sm" v-show="errors.has('new-license-form.key')">
            {{ errors.first('new-license-form.key') }}
          </span>
        </div>
        <vs-divider></vs-divider>
        <div class="flex flex-wrap justify-between">
          <div class="w-full">
            <vs-button class="float-right">
              {{ $t('_pages.popup_expired.redeem_license') }}
            </vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>

</template>


<script>
import { mapActions } from "vuex";
import moment from 'moment'
import { environment } from "@/_helpers";

export default {
  data() {
    return {
      email: "",
      first_name: "",
      last_name: "",
      password: "",
      password_confirmation: "",
      license_key: "",
      license_end: "",
      license_end_color: "",
      change_password: false,
      mail_risk_informative: true,
      mail_risk_low: true,
      mail_risk_moderate: true,
      mail_risk_high: true,
      lang: "",
      key_mask: environment().key_mask,
      new_license: false,
      key: "",
      license_expired: "",
      rescue_name: ""
    };
  },
  methods: {
    ...mapActions("customer", ["info", "update_info", "rescue_license"]),
    clearPass() {
      this.password = "";
      this.password_confirmation = "";
    },
    getInfo() {
      const vm = this;
      return this.info().then(info => {
        let licenseExpired = (info.license_status == "expired");

        vm.email = info.email;
        vm.first_name = info.first_name;
        vm.last_name = info.last_name;
        vm.license_key = info.license_key;
        vm.license_end = moment(String(info.license_end)).format('DD/MM/YYYY');
        vm.license_end_color = licenseExpired? "text-danger": "text-success";
        vm.license_expired = licenseExpired;
        vm.mail_risk_informative = info.mail_risk_informative;
        vm.mail_risk_low = info.mail_risk_low;
        vm.mail_risk_moderate = info.mail_risk_moderate;
        vm.mail_risk_high = info.mail_risk_high;
        vm.lang = info.lang;
      });
    },
    activeNewLicense(scope) {
      const vm = this;
      this.$validator.validateAll(scope).then(valid => {
          if (valid) {
              this.$vs.loading();

              const { key } = this;
              const payload = {
                  info: { key }
              };

              this.rescue_license(payload).then(
                  response => {
                      this.$vs.loading.close();
                      this.$vs.notify({
                          title: vm.$t("_codes.e" + response.code, {
                              code: response.code
                          }),
                          text: vm.$t("_pages.profile.license_update"),
                          iconPack: "feather",
                          icon: "icon-check",
                          color: "success"
                      });

                      vm.license_end = moment(String(response.data.end_date)).format('DD/MM/YYYY');
                      vm.license_end_color = "text-success";
                      vm.license_expired = false;
                      vm.new_license = false;
                      vm.license_key = vm.key;
                  },
                  error => {
                      this.$vs.loading.close();
                      this.$vs.notify({
                          title: vm.$t("_codes.e" + error.code, { code: error.code }),
                          text: vm.$t("_pages.profile.license_not_updated"),
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "warning"
                      });
                  }
              );
          }
      });
    },
    handleSubmit(scope) {
      const vm = this;
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.$vs.loading();

          const { first_name, last_name, email, password, mail_risk_informative, mail_risk_low, mail_risk_moderate, mail_risk_high, lang } = this;
          const payload = {
            info: { first_name, last_name, email, lang }
          };

          if (vm.change_password) {
            payload.info["password"] = password;
          }

          if (vm.mail_risk_informative) {
            payload.info["mail_risk_informative"] = mail_risk_informative;
          }

          if (vm.mail_risk_low) {
            payload.info["mail_risk_low"] = mail_risk_low;
          }

          if (vm.mail_risk_moderate) {
            payload.info["mail_risk_moderate"] = mail_risk_moderate;
          }

          if (vm.mail_risk_high) {
            payload.info["mail_risk_high"] = mail_risk_high;
          }

          this.update_info(payload).then(
            response => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: vm.$t("_codes.e" + response.code, {
                  code: response.code
                }),
                text: vm.$t("_pages.profile.success_message"),
                iconPack: "feather",
                icon: "icon-check",
                color: "success"
              });

              vm.change_password = false;
              this.$store.commit("UPDATE_CUSTOMER_DATA", {
                first_name: first_name,
                last_name: last_name,
                email: email,
                mail_risk_informative: mail_risk_informative,
                mail_risk_low: mail_risk_low,
                mail_risk_moderate: mail_risk_moderate,
                mail_risk_high: mail_risk_high,
                lang: lang
              });
            },
            error => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: vm.$t("_codes.e" + error.code, { code: error.code }),
                text: vm.$t("_pages.profile.warning_message"),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });
            }
          );
        }
      });
    },
    data_export() {
        window.open("https://skymonitor.freshdesk.com/support/solutions/articles/61000294949-solicitac%C3%A3o-de-dados-lgpd", "_blank");
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.$emit("teste");
  }
};
</script>